/**
 * HTTP Data API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { DeviceWithDeploymentDto } from './deviceWithDeploymentDto';


export interface VirtualFenceRequestDto { 
    orderBy?: string;
    orderDirection?: string;
    afterUTC?: string;
    beforeUTC?: string;
    afterSCTS?: string;
    beforeSCTS?: string;
    originCodes?: Array<VirtualFenceRequestDto.OriginCodesEnum>;
    deviceIds?: Array<number>;
    animalIds?: Array<number>;
    devicesWithDeployments?: Array<DeviceWithDeploymentDto>;
    page?: number;
    count?: number;
    lastX?: number;
    gtId?: number;
    columnKeywordsList?: Array<string>;
    extendedMessageTypes?: Array<VirtualFenceRequestDto.ExtendedMessageTypesEnum>;
    sensorIDCodes?: Array<number>;
    deployedOnly?: boolean;
    vfEntered?: boolean;
    minLatitude?: number;
    maxLatitude?: number;
    minLongitude?: number;
    maxLongitude?: number;
}
export namespace VirtualFenceRequestDto {
    export const OriginCodesEnum = {
        Globalstar: 'GLOBALSTAR',
        Iridium: 'IRIDIUM',
        GsmSms: 'GSM_SMS',
        GsmFtp: 'GSM_FTP',
        Terminal: 'TERMINAL',
        Collar: 'COLLAR',
        NbIot: 'NB_IOT',
        IridiumEmail: 'IRIDIUM_EMAIL'
    } as const;
    export type OriginCodesEnum = typeof OriginCodesEnum[keyof typeof OriginCodesEnum];
    export const ExtendedMessageTypesEnum = {
        NoContact: 'NO_CONTACT',
        Mortality: 'MORTALITY',
        Status: 'STATUS',
        Null: 'NULL',
        Expelled: 'EXPELLED'
    } as const;
    export type ExtendedMessageTypesEnum = typeof ExtendedMessageTypesEnum[keyof typeof ExtendedMessageTypesEnum];
}


